import React from 'react';

import {
  Divider,
  Stack,
  Typography,
} from '@mui/material';

import ProfileIcon from '../ProfileIcon';

interface UserListItemProps {
  firstName: string,
  lastName: string,
  label?: string,
  profileIconColor?: `#${string}`,
  profileIconImage?: string,
  displayedProprties?: string[],
  renderStateChip?: () => React.ReactElement,
}

const UserListItem = ({
  firstName,
  lastName,
  label,
  profileIconColor,
  profileIconImage,
  displayedProprties,
  renderStateChip,
  ...props
}: UserListItemProps) => (
  <li {...props}>
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
      >
        <ProfileIcon
          firstName={firstName}
          lastName={lastName}
          color={profileIconColor}
          imageUrl={profileIconImage}
          size={36}
        />
        <Stack direction="column">
          <Typography fontWeight="bold">
            {label || `${firstName} ${lastName}`}
          </Typography>
          <Stack
            direction="row"
            spacing={1}
            divider={
              <Divider orientation="vertical" flexItem />
            }
            alignItems="center"
          >
            {displayedProprties?.map((property) => (
              <Typography variant="body2">
                {property}
              </Typography>
            ))}
          </Stack>
        </Stack>
        {renderStateChip && renderStateChip()}
      </Stack>
    </Stack>
  </li>
);
export default UserListItem;
